export const initialState = {
    documentsList: [],
    documentDetails: null,
    agendaListForDocument: [],
    meetingListForDocument: [],
    documentViews: [],
    landingPageDocumentsList: [],
    landingPageDocumentDetails: null,
};

const state = { ...initialState };

export default state;